import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { INote } from '@/models/note';

import { http } from './http';
import { IGetParams, IPaginatedListResponse } from './types';
import { IMasterName } from '../models/master.names';

export const MasterVehicleApi = {
  addMasterNameNote: (
    nameId: string,
    description: string,
  ): Promise<AxiosResponse<INote>> => {
    return http.post(`api/${ApiVersion.V1}/master-names/${nameId}/notes`, {
      description,
    });
  },
  getMasterVehicleNotes: (
    id: string,
    params: IGetParams,
  ): Promise<AxiosResponse<INote[]>> => {
    return http.get(
      `api/${ApiVersion.V1}/vehicles/master-vehicles/${id}/notes`,
      {
        params: { ...params },
      },
    );
  },
  getPaginatedMasterVehicleNotes: (
    id: string,
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<INote>>> => {
    return http.get(
      `api/${ApiVersion.V1}/vehicles/master-vehicles/${id}/notes/list`,
      {
        params: { ...params },
      },
    );
  },
  addMasterVehiclesNote: (
    vehicleId: string,
    description: string,
  ): Promise<AxiosResponse<INote>> => {
    return http.post(
      `api/${ApiVersion.V1}/vehicles/master-vehicles/${vehicleId}/notes`,
      {
        description,
      },
    );
  },
  updateMasterVehicleNote: (
    vehicleId: string,
    noteId: string,
    description: string,
  ): Promise<AxiosResponse<INote>> => {
    return http.put(
      `api/${ApiVersion.V1}/vehicles/master-vehicles/${vehicleId}/notes/${noteId}`,
      { description },
    );
  },
  deleteMasterVehicleNote: (
    id: string,
    noteId: string,
  ): Promise<AxiosResponse<IMasterName>> => {
    return http.delete(
      `api/${ApiVersion.V1}/vehicles/master-vehicles/${id}/notes/${noteId}`,
    );
  },
};
